export default __webpack_public_path__ + "static/media/banners.7c7d371a.svg";